import { render, staticRenderFns } from "./ComCulture.vue?vue&type=template&id=3e6131dd&scoped=true&"
import script from "./ComCulture.vue?vue&type=script&lang=js&"
export * from "./ComCulture.vue?vue&type=script&lang=js&"
import style0 from "./ComCulture.vue?vue&type=style&index=0&id=3e6131dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6131dd",
  null
  
)

export default component.exports